import { IQuotas } from 'types/quotas.types';
import {
  BO_GET_COMPANY_DETAILS_FAILURE,
  BO_GET_COMPANY_DETAILS_REQUEST,
  BO_GET_COMPANY_DETAILS_SUCCESS,
  BO_GET_USER_DETAILS,
  BO_GET_USER_DETAILS_FAILURE,
  BO_GET_USER_DETAILS_SUCCESS,
  GET_BO_COMPANY_QUOTA_DETAILS_FAILURE,
  GET_BO_COMPANY_QUOTA_DETAILS_REQUEST,
  GET_BO_COMPANY_QUOTA_DETAILS_SUCCESS,
  GET_BO_COMPANY_MONTHLY_STATS_REQUEST,
  GET_BO_COMPANY_MONTHLY_STATS_SUCCESS,
  GET_BO_COMPANY_MONTHLY_STATS_FAILURE,
  GET_LAZY_LOGIN_TOKEN,
  GET_LAZY_LOGIN_TOKEN_FAILURE,
  GET_LAZY_LOGIN_TOKEN_SUCCESS,
  GET_BO_COMPANY_TEAM_MEMBERS_STATS_REQUEST,
  GET_BO_COMPANY_TEAM_MEMBERS_STATS_SUCCESS,
  GET_BO_COMPANY_TEAM_MEMBERS_STATS_FAILURE,
  GET_BO_LEDGER_DETAILS_SUCCESS,
  GET_BO_LEDGER_DETAILS_REQUEST,
  GET_BO_LEDGER_DETAILS_FAILURE,
} from '../../constants/ActionTypes';
import {
  IBackofficeCompany,
  IBackofficeUserData,
  GetCompanyDetailsRequestAction,
  GetCompanyDetailsSuccessAction,
  GetCompanyDetailsFailureAction,
  GetUserDetailsAction,
  GetUserDetailsSuccessAction,
  GetUserDetailsFailureAction,
  GetLazyLoginTokenAction,
  GetLazyLoginTokenSuccessAction,
  GetLazyLoginTokenFailureAction,
  GetBoCompanyQuotaDetailsSuccessAction,
  GetBoCompanyQuotaDetailsFailureAction,
  GetBoCompanyQuotaDetailsRequestAction,
  GetBoCompanyMonthlyStatsRequestAction,
  GetBoCompanyMonthlyStatsSuccessAction,
  GetBoCompanyMonthlyStatsFailureAction,
  GetBoCompanyTeamMembersStatsRequestAction,
  GetBoCompanyTeamMembersStatsSuccessAction,
  GetBoCompanyTeamMembersStatsFailureAction,
  IBackofficeCompanyTeamMemberStats,
  GetBoLedgerDetailsSuccessAction,
  ILedgerDetails,
  GetBoLedgerDetailsRequestAction,
  ILedgerFilterPayload,
  GetBoLedgerDetailsFailureAction,
} from '../../types/backoffice.types';
import { ICompanyMonthlyStats } from 'types/companyMonthlyStats.types';

export const getCompanyDetailsRequest = (
  companySlug: string
): GetCompanyDetailsRequestAction => ({
  type: BO_GET_COMPANY_DETAILS_REQUEST,
  payload: { companySlug },
});

export const getCompanyDetailsSuccess = (
  companyDetails: IBackofficeCompany
): GetCompanyDetailsSuccessAction => ({
  type: BO_GET_COMPANY_DETAILS_SUCCESS,
  payload: { companyDetails },
});

export const getCompanyDetailsFailure = (
  error: string
): GetCompanyDetailsFailureAction => ({
  type: BO_GET_COMPANY_DETAILS_FAILURE,
  payload: { error },
});

export const getUserDetails = (username: string): GetUserDetailsAction => ({
  type: BO_GET_USER_DETAILS,
  payload: username,
});

export const getUserDetailsSuccess = (
  data: IBackofficeUserData
): GetUserDetailsSuccessAction => ({
  type: BO_GET_USER_DETAILS_SUCCESS,
  payload: data,
});

export const getUserDetailsFailure = (
  error: string
): GetUserDetailsFailureAction => ({
  type: BO_GET_USER_DETAILS_FAILURE,
  payload: error,
});

export const getLoazyLoginToken = (
  username: string,
  companySlug: string
): GetLazyLoginTokenAction => ({
  type: GET_LAZY_LOGIN_TOKEN,
  payload: { username, companySlug },
});

export const getLoazyLoginTokenSuccess = (
  data: any
): GetLazyLoginTokenSuccessAction => ({
  type: GET_LAZY_LOGIN_TOKEN_SUCCESS,
  payload: data,
});

export const getLoazyLoginTokenFailure = (
  error: string
): GetLazyLoginTokenFailureAction => ({
  type: GET_LAZY_LOGIN_TOKEN_FAILURE,
  payload: error,
});

export const getBackofficeCompanyQuotaDetailsRequest = (
  companySlug: string,
  username: string
): GetBoCompanyQuotaDetailsRequestAction => ({
  type: GET_BO_COMPANY_QUOTA_DETAILS_REQUEST,
  payload: { companySlug, username },
});

export const getBackofficeCompanyQuotaDetailsSuccess = (
  quotaDetails: IQuotas
): GetBoCompanyQuotaDetailsSuccessAction => ({
  type: GET_BO_COMPANY_QUOTA_DETAILS_SUCCESS,
  payload: { quotaDetails },
});

export const getBackofficeCompanyQuotaDetailsFailure = (
  error: string
): GetBoCompanyQuotaDetailsFailureAction => ({
  type: GET_BO_COMPANY_QUOTA_DETAILS_FAILURE,
  payload: { error },
});

export const getBackofficeMonthlyStatsDetailsRequest = (
  companySlug: string,
  username: string
): GetBoCompanyMonthlyStatsRequestAction => ({
  type: GET_BO_COMPANY_MONTHLY_STATS_REQUEST,
  payload: { companySlug, username },
});

export const getBackofficeMonthlyStatsDetailsSuccess = (
  companyMonthlyStats: ICompanyMonthlyStats
): GetBoCompanyMonthlyStatsSuccessAction => ({
  type: GET_BO_COMPANY_MONTHLY_STATS_SUCCESS,
  payload: { companyMonthlyStats },
});

export const getBackofficeMonthlyStatsDetailsFailure = (
  error: string
): GetBoCompanyMonthlyStatsFailureAction => ({
  type: GET_BO_COMPANY_MONTHLY_STATS_FAILURE,
  payload: { error },
});

export const getBackofficeCompanyTeamMembersStatsRequest = (
  companySlug: string,
  username: string
): GetBoCompanyTeamMembersStatsRequestAction => ({
  type: GET_BO_COMPANY_TEAM_MEMBERS_STATS_REQUEST,
  payload: { companySlug, username },
});

export const getBackofficeCompanyTeamMembersStatsSuccess = (
  teamMembersStats: IBackofficeCompanyTeamMemberStats
): GetBoCompanyTeamMembersStatsSuccessAction => ({
  type: GET_BO_COMPANY_TEAM_MEMBERS_STATS_SUCCESS,
  payload: { teamMembersStats },
});

export const getBackofficeCompanyTeamMembersStatsFailure = (
  error: string
): GetBoCompanyTeamMembersStatsFailureAction => ({
  type: GET_BO_COMPANY_TEAM_MEMBERS_STATS_FAILURE,
  payload: { error },
});

export const getBoLedgerDetailsRequest = (
  ledgerFilterPayload: ILedgerFilterPayload
): GetBoLedgerDetailsRequestAction => ({
  type: GET_BO_LEDGER_DETAILS_REQUEST,
  payload: ledgerFilterPayload,
});

export const getBoLedgerDetailsSuccess = (
  ledgerDetails: ILedgerDetails
): GetBoLedgerDetailsSuccessAction => ({
  type: GET_BO_LEDGER_DETAILS_SUCCESS,
  payload: { ledgerDetails },
});

export const getBoLedgerDetailsFailure = (
  error: string
): GetBoLedgerDetailsFailureAction => ({
  type: GET_BO_LEDGER_DETAILS_FAILURE,
  payload: { error },
});

export type BackofficeActions =
  | GetBoCompanyTeamMembersStatsRequestAction
  | GetBoCompanyTeamMembersStatsSuccessAction
  | GetBoCompanyTeamMembersStatsFailureAction
  | GetBoCompanyMonthlyStatsRequestAction
  | GetBoCompanyMonthlyStatsSuccessAction
  | GetBoCompanyMonthlyStatsFailureAction
  | GetBoCompanyQuotaDetailsRequestAction
  | GetBoCompanyQuotaDetailsSuccessAction
  | GetBoCompanyQuotaDetailsFailureAction
  | GetCompanyDetailsRequestAction
  | GetCompanyDetailsSuccessAction
  | GetCompanyDetailsFailureAction
  | GetUserDetailsAction
  | GetUserDetailsSuccessAction
  | GetUserDetailsFailureAction
  | GetLazyLoginTokenAction
  | GetLazyLoginTokenSuccessAction
  | GetLazyLoginTokenFailureAction
  | GetBoLedgerDetailsRequestAction
  | GetBoLedgerDetailsSuccessAction
  | GetBoLedgerDetailsFailureAction;
